<template>
  <div>
    <div v-if="!isSelfPay" class="financing-content">
      <p>
        Sie werden in <span class="make-red make-bold">5 Sekunden</span> zu
        unserer Partner-Bank weitergeleitet, um Ihre Finanzierungsanfrage
        abschließen zu können. Den Kaufvertrag erhalten Sie nach genehmigter
        Finanzierung von uns per Mail.
      </p>
      <div class="spinner-indicator">
        <div class="dot-spin"></div>
      </div>
      <p>
        Falls Sie nicht automatisch weitergeleitet werden, klicken Sie
        <a v-bind:href="this.redirectURL" target="_blank" class="make-red"
          >hier.</a
        >
      </p>
    </div>

    <!-- TODO: Remove bellow the code that belongs to !isSelfPay condition -->
    <div
      v-if="
        (isFormView && !isSelfPay && !contactPreferences) ||
          (isFormView && isSelfPay)
      "
      :class="['contract-number__content', { 'with-error': contactWayError }]"
    >
      <dl class="contract-number">
        <dt>Auftragsnummer:</dt>
        <dd>{{ number }}</dd>
      </dl>
      <h2>
        <template v-if="isSelfPay">Vielen Dank für Ihre Anfrage!</template>
      </h2>
      <p class="orange-hint" v-if="isSelfPay">
        <i class="fa fa-paper-plane" /> Der Kaufvertrag ist auf dem Weg zu
        Ihnen.
      </p>
      <p class="padding">
        <template v-if="isSelfPay">
          Ihre Anfrage ist bei uns eingegangen und wird derzeit bearbeitet! Den
          Kaufvertrag erhalten Sie zur Einsicht via E-Mail. Sie können den
          Kaufvertrag ganz einfach online unterschreiben.
        </template>
      </p>
      <div class="friday-warranty" v-if="fridayInsuranceSelected">
        <hr v-if="isSelfPay" />
        <template v-if="!isSelfPay">
          <h4>Unverbindliches Versicherungsangebot</h4>
          <p>
            In der Bestätigungsmail über Ihre eingegangene Anfrage ist der Link
            zu unserem Partner Friday enthalten. Über den Link werden Sie zu
            Friday weitergeleitet. Dort können Sie eine unverbindliches
            Versicherungsangebot ganz einfach und bequem online anfragen. Die
            Erstellung der Anfrage dauert nur 90 Sekunden.
          </p>
        </template>
        <template v-if="isSelfPay">
          <h3>Jetzt unverbindliches Versicherungsangebot einholen</h3>
          <p>
            Fragen Sie bei unserem Partner Friday ein unverbindliches
            Versicherungsangebot ganz einfach und bequem online an. Die
            Erstellung der Anfrage dauert nur 90 Sekunden. Durch den Klick auf
            den Button werden Sie zu Friday weitergeleitet.
          </p>
          <span class="btn wide" @click="goToFridayInsuranceSite">
            Unverbindliches Versicherungsangebot einholen</span
          >
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { sendContactForm, getRedirectUrl } from "@/api/checkout";
import Contacts from "./Contacts";

export default {
  components: {
    Contacts,
  },
  props: [
    "number",
    "carId",
    "phone",
    "userName",
    "contactPreferences",
    "paymentMethod",
    "token",
    "carDetails",
  ],
  data() {
    return {
      redirectURL: "",
      contactWay: "",
      contactWayError: false,
      sending: false,
      availableTime: [],
      isFormView: true,
    };
  },
  computed: {
    isSelfPay() {
      return this.paymentMethod === "self_pay";
    },
    fridayInsuranceSelected() {
      return JSON.parse(sessionStorage.getItem("order")).friday_insurance;
    },
  },
  watch: {
    contactWay(val) {
      if (val && this.contactWayError) {
        this.contactWayError = false;
      }
    },
  },
  mounted() {
    this.trackEUTevent();
    this.makeRedirect();
  },
  methods: {
    async makeRedirect() {
      if (this.paymentMethod === "self_pay") {
        return;
      }

      try {
        const { redirect_url } = await getRedirectUrl(this.token);
        this.redirectURL = redirect_url;

        const openRedirect = () => window.open(redirect_url, "_blank");
        setTimeout(openRedirect, 5000);
      } catch (e) {
        console.log("e", e);
      }
    },
    goToFridayInsuranceSite() {
      window.open(this.carDetails.friday_url, "_blank").focus();
    },

    sendAvailableTime(e) {
      e.preventDefault();
      const isValid = this.validateForm();
      if (isValid) {
        this.sending = true;
        const text =
          this.contactWay === "phone"
            ? "Ich bin jederzeit telefonisch erreichbar"
            : this.availableTime.join(", ");
        const contactNote = `Telefon: ${this.phone} - Auftragsnummer: ${this.number} - Erreichbarkeit: ${text}.`;
        const params = {
          email: "onlinekauf@pkw.de",
          name: this.userName,
          contact_note: contactNote,
        };
        sendContactForm(this.carId, params).then(() => {
          this.sending = false;
          this.isFormView = false;
        });
      }
    },
    validateForm() {
      let noError = true;
      if (this.contactWay === "") {
        this.contactWayError = true;
        noError = false;
      } else if (this.contactWay === "time" && !this.availableTime.length) {
        this.contactWayError = true;
        noError = false;
      } else {
        this.contactWayError = false;
      }
      if (noError) {
        this.contactWayError = false;
      }
      return noError;
    },
    goToBankAgreements() {
      getRedirectUrl(this.token).then((res) => {
        window.open(res.redirect_url, "_blank");
      });
    },
    trackEUTevent() {
      const carName =
        this.carDetails.brand.name + " " + this.carDetails.model.name;
      const orderId = this.number;
      const price = this.carDetails.price.customer;
      window.uetq = window.uetq || [];
      window.uetq.push("event", carName, {
        ecomm_prodid: orderId,
        ecomm_pagetype: "purchase",
        ecomm_totalvalue: price,
        revenue_value: 1,
        currency: "EUR",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.contract-number__content {
  padding: 10px;

  @include breakpoint(tablet) {
    background: white;
    box-shadow: 0 0 30px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    padding: 20px;
    max-width: 450px;
    margin: 2rem auto;

    h2 {
      font-size: 30px;
    }
    h3 {
      font-size: 20px;
      margin-bottom: 10px;
    }
  }

  @include breakpoint(medium) {
    max-width: none;
    padding: 20px 40px;

    .contract-number {
      margin-bottom: 40px;
    }
  }

  @include breakpoint(desktop) {
    .flex {
      display: flex;
      justify-content: space-between;
      align-items: center;

      p {
        flex: 15;
        margin-right: 20px;
      }

      .btn {
        flex: 10;
      }
    }
  }

  .friday-warranty {
    h4,
    h3 {
      font-size: 18px;
      padding-bottom: 10px;
    }
    p {
    }
  }
  .orange-hint {
    display: inline-block;
    margin: 10px 0;
    padding: 10px 0;
    font-weight: 600;
    border-bottom: 1px solid $red;
    color: $red;
  }

  button {
    position: relative;
    display: block;
    width: 100%;
    max-width: 350px;
    padding: 15px 10px;
    margin: 20px 0 15px;
    font-size: 16px;
    font-weight: 600;
    text-align: center;
    background-color: $red;
    color: $white;
    transition: all 0.5s;
    border-radius: 50px;
    &:after {
      @include icon("\f105", $white, 18px);
    }
    &:hover,
    &:focus,
    &:active {
      background: $darkgray;
    }
  }

  p {
    font-size: 16px;
    line-height: 24px;
  }

  hr {
    opacity: 0.2;
    margin: 20px 0;
  }

  .btn {
    margin-bottom: 20px;
    text-align: center;
  }

  h2 {
    padding: 0;
    font-weight: 400;
  }

  h3 {
    padding: 0;
    font-weight: 400;
  }

  .btn {
    margin-top: 10px;
  }
  .radio-form-item {
    margin-bottom: 10px;
    &__top-content {
      h4 {
        margin-bottom: 10px;
      }
      > p {
        margin-left: 30px;
      }
    }
  }
  .financed-plan {
    margin-left: 30px;
  }
  .financed-plan__label {
    display: block;
  }
  &.with-error {
    .radio-form-item {
      border-color: $red;
    }
    .title {
      color: $red;
    }
    .error {
      font-size: 12px;
      line-height: 24px;
      color: $red;
    }
  }
}
.colored-text {
  margin: 20px 0;
  font-weight: 700;
  color: #0bb395;
}

.calendly {
  text-decoration: none;

  &:hover,
  &:focus,
  &:active {
    span {
      background: $darkgray;
      color: white;
      border-color: $darkgray;

      &:after {
        color: white;
      }
    }
  }

  img {
    max-width: 100%;
    display: block;
  }
}
.success-message {
  p {
    font-size: 16px;
    line-height: 26px;
  }
}
.thank-you {
  padding: 1rem;
  margin-bottom: 40px;
  background: #d5f3d5;

  h2 {
    color: green;
  }

  p {
    margin-bottom: 0;
  }
}

.financing-content {
  max-width: 480px;
  line-height: 24px;
  text-align: center;
  margin: 0 auto;
  margin-top: 30px;
  padding: 0 15px;

  .make-red {
    color: $red;
  }

  .make-bold {
    font-weight: 700;
  }

  .spinner-indicator {
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  a {
    text-decoration: underline;
  }
}

.dot-spin {
  position: relative;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: transparent;
  color: transparent;
  box-shadow: 0 -18px 0 0 $red, 12.727926px -12.727926px 0 0 $red,
    18px 0 0 0 $red, 12.727926px 12.727926px 0 0 rgba(152, 128, 255, 0),
    0 18px 0 0 rgba(152, 128, 255, 0),
    -12.727926px 12.727926px 0 0 rgba(152, 128, 255, 0),
    -18px 0 0 0 rgba(152, 128, 255, 0),
    -12.727926px -12.727926px 0 0 rgba(152, 128, 255, 0);
  animation: dot-spin 1.5s infinite linear;
}

@keyframes dot-spin {
  0%,
  100% {
    box-shadow: 0 -18px 0 0 $red, 12.727926px -12.727926px 0 0 $red,
      18px 0 0 0 $red, 12.727926px 12.727926px 0 -5px rgba(152, 128, 255, 0),
      0 18px 0 -5px rgba(152, 128, 255, 0),
      -12.727926px 12.727926px 0 -5px rgba(152, 128, 255, 0),
      -18px 0 0 -5px rgba(152, 128, 255, 0),
      -12.727926px -12.727926px 0 -5px rgba(152, 128, 255, 0);
  }
  12.5% {
    box-shadow: 0 -18px 0 -5px rgba(152, 128, 255, 0),
      12.727926px -12.727926px 0 0 $red, 18px 0 0 0 $red,
      12.727926px 12.727926px 0 0 $red, 0 18px 0 -5px rgba(152, 128, 255, 0),
      -12.727926px 12.727926px 0 -5px rgba(152, 128, 255, 0),
      -18px 0 0 -5px rgba(152, 128, 255, 0),
      -12.727926px -12.727926px 0 -5px rgba(152, 128, 255, 0);
  }
  25% {
    box-shadow: 0 -18px 0 -5px rgba(152, 128, 255, 0),
      12.727926px -12.727926px 0 -5px rgba(152, 128, 255, 0), 18px 0 0 0 $red,
      12.727926px 12.727926px 0 0 $red, 0 18px 0 0 $red,
      -12.727926px 12.727926px 0 -5px rgba(152, 128, 255, 0),
      -18px 0 0 -5px rgba(152, 128, 255, 0),
      -12.727926px -12.727926px 0 -5px rgba(152, 128, 255, 0);
  }
  37.5% {
    box-shadow: 0 -18px 0 -5px rgba(152, 128, 255, 0),
      12.727926px -12.727926px 0 -5px rgba(152, 128, 255, 0),
      18px 0 0 -5px rgba(152, 128, 255, 0), 12.727926px 12.727926px 0 0 $red,
      0 18px 0 0 $red, -12.727926px 12.727926px 0 0 $red,
      -18px 0 0 -5px rgba(152, 128, 255, 0),
      -12.727926px -12.727926px 0 -5px rgba(152, 128, 255, 0);
  }
  50% {
    box-shadow: 0 -18px 0 -5px rgba(152, 128, 255, 0),
      12.727926px -12.727926px 0 -5px rgba(152, 128, 255, 0),
      18px 0 0 -5px rgba(152, 128, 255, 0),
      12.727926px 12.727926px 0 -5px rgba(152, 128, 255, 0), 0 18px 0 0 $red,
      -12.727926px 12.727926px 0 0 $red, -18px 0 0 0 $red,
      -12.727926px -12.727926px 0 -5px rgba(152, 128, 255, 0);
  }
  62.5% {
    box-shadow: 0 -18px 0 -5px rgba(152, 128, 255, 0),
      12.727926px -12.727926px 0 -5px rgba(152, 128, 255, 0),
      18px 0 0 -5px rgba(152, 128, 255, 0),
      12.727926px 12.727926px 0 -5px rgba(152, 128, 255, 0),
      0 18px 0 -5px rgba(152, 128, 255, 0), -12.727926px 12.727926px 0 0 $red,
      -18px 0 0 0 $red, -12.727926px -12.727926px 0 0 $red;
  }
  75% {
    box-shadow: 0 -18px 0 0 $red,
      12.727926px -12.727926px 0 -5px rgba(152, 128, 255, 0),
      18px 0 0 -5px rgba(152, 128, 255, 0),
      12.727926px 12.727926px 0 -5px rgba(152, 128, 255, 0),
      0 18px 0 -5px rgba(152, 128, 255, 0),
      -12.727926px 12.727926px 0 -5px rgba(152, 128, 255, 0), -18px 0 0 0 $red,
      -12.727926px -12.727926px 0 0 $red;
  }
  87.5% {
    box-shadow: 0 -18px 0 0 $red, 12.727926px -12.727926px 0 0 $red,
      18px 0 0 -5px rgba(152, 128, 255, 0),
      12.727926px 12.727926px 0 -5px rgba(152, 128, 255, 0),
      0 18px 0 -5px rgba(152, 128, 255, 0),
      -12.727926px 12.727926px 0 -5px rgba(152, 128, 255, 0),
      -18px 0 0 -5px rgba(152, 128, 255, 0), -12.727926px -12.727926px 0 0 $red;
  }
}
</style>
